import React, { useEffect, useRef, useState } from 'react';
import { ZoInputText } from '../zo-input-text-temp/zo-input-text-temp';
import './countries-list.scss';
import { SVGS } from '../assets';
import { COUNTRIES_DATA, CountryObject } from '@zonofi/i18n';

interface CountriesListProps {
  closeCountriesDrawer: () => void;
  selectedCountry: CountryObject;
  setSelectedCountry: (val: CountryObject) => void;
  showCountryCode?: boolean;
}

export const CountriesList: React.FC<CountriesListProps> = ({
  closeCountriesDrawer,
  selectedCountry,
  setSelectedCountry,
  showCountryCode = false,
}) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const selectedCountryRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (selectedCountryRef.current) {
      selectedCountryRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [selectedCountry]);

  return (
    <div className="countries-list">
      <div className="countries-list-header">
        <ZoInputText
          name=""
          onBlur={() => {}}
          startAdornment={<img src={SVGS.SearchIcon} alt="" />}
          placeholder="Search"
          inputFieldProps={{
            onChange: (e) => {
              const val = e.target.value;
              if (/^[A-Za-z]*$/.test(val)) {
                setSearchValue(val);
              }
            },
          }}
          value={searchValue}
        />
      </div>
      <div className="countries-list-body">
        {COUNTRIES_DATA.filter(
          (country) =>
            country.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            country.code.toLowerCase().includes(searchValue.toLowerCase())
        ).map((country: CountryObject, index) => {
          const isSelected =
            selectedCountry && selectedCountry?.code === country.code;
          return (
            <div
              className={`countries-list-body-item ${
                isSelected ? 'selected' : ''
              }`}
              ref={isSelected ? selectedCountryRef : null}
              onClick={() => {
                setSelectedCountry(country);
                closeCountriesDrawer();
              }}
              key={index}
            >
              <span className="countries-list-body-item-flag">
                {country?.flag}
              </span>
              <span className="countries-list-body-item-name primary-font-regular">
                {country?.name}
              </span>
              {showCountryCode && (
                <span className="countries-list-body-item-code primary-font-regular">
                  ({country?.dial_code})
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
